module.exports = __webpack_public_path__ + "fonts/fa-brands-400.f861a57c.woff2";